import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let tongjiChildren = (data, index, Vue) => {
  var arr = [];
  // var shape = ['总开', '最多连开', '当前遗漏', '最大遗漏'];
  var shape = ['总开', '未开'];

  var str = ['allOpen', 'nowOmit', 'maxOmit'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index}`;
        var ball = row.row[name][str[i]];
        if (Vue.maxNumOne >= ball && ball >= Vue.minNumOne) {
          return <span class="span_red">{ball ? ball : 0}</span>;
        } else if (Vue.maxNumTwo >= ball && ball >= Vue.minNumTwo) {
          return <span class="span_two">{ball ? ball : 0}</span>;
        } else if (Vue.maxNumThr >= ball && ball >= Vue.minNumThr) {
          return <span class="span_thr">{ball ? ball : 0}</span>;
        }
        return <span>{ball ? ball : 0}</span>;

        if (row.row[name][str[i]]) {
          return <span>{row.row[name][str[i]]}</span>;
        } else {
          return <span>0</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const hpten = (data, ballindex) => {
  let list = Vue => {
    let arr = [
      {
        title: '号码',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 72,
        // render: (h, row) => {
        //   return <span class={`c${row.index + 1}`} />;
        // }
        render: (h, row) => {
          return <span>{row.index + 1}</span>;
        }
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    var keys = Object.keys(data[0]);
    for (let i = 0; i < keys.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.width = '300';
      obj.className = `table_info_column_${i}`;
      obj.children = tongjiChildren(data, i + 1, Vue);
      arr.push(obj);
    }
    return arr;
  };
  return { list };
};

export default hpten;



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomatongji/columns/hpten.js